








































































































































































































































import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { mapState } from 'vuex';

import { LGeoJson } from "vue2-leaflet";
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';
import { objectIsEmpty } from '~/utils/common.js';

import LayersOutline from '~/components/icons/LayersOutline.vue';
import NavigationOutline from '~/components/icons/NavigationOutline.vue';
import XSolid from '~/components/icons/XSolid.vue';
import LocalisationDestinationCard from '~/components/cards/LocalisationDestinationCard.vue';
import EventCard from '~/components/cards/EventCard.vue';
import RefreshOutline from '~/components/icons/RefreshOutline.vue';
import LocalisationRouteCard from '~/components/cards/LocalisationRouteCard.vue';
import ExtendedPopup from '~/components/partials/ExtendedPopup.vue';
import { ignScan25Url, ignStandardUrl } from "~/utils/map";

@Component({
  components: {
    LayersOutline,
    NavigationOutline,
    XSolid,
    'v-marker-cluster': Vue2LeafletMarkerCluster,
    'v-geo-json': LGeoJson,
    LocalisationDestinationCard,
    EventCard,
    RefreshOutline,
    LocalisationRouteCard,
    ExtendedPopup,
  },
  computed: {
    ...mapState('explorer', [
      'userCoords',
      'destinationsList',
      'routesList',
      'eventsList',
      'hoveredRoutes',
    ]),
    ...mapState('lang', [
      'locale',
    ]),
  },
})
export default class ExplorerMap extends Vue {
    @Prop(String) customHeight: '';
    @Prop(Boolean) isInLocalisationContext: false;
    @Prop(Array) destinations: Array<Types.DestinationMap>;
    @Prop(Array) routes: Array<Types.RouteMap>;
    @Prop(Array) events: Array<Types.EventMap>;
    @Prop(Boolean) hideControls: false;
    @Prop(Object) hoveredDestination: {};
    @Prop(Object) hoveredEvent: {};
    @Prop(Object) hoveredRoute: Types.Route;
    @Prop(Array) customBounds: number[];
    @Prop(Boolean) hideUserLoc: false;
    @Prop(String) activeTab: 'routes' | 'events' | 'destinations';
    @Prop(Boolean) isDisplayed: false;

    $refs: {
      map: any,
      zoomContainer: any,
      routeCluster: any,
      eventCluster: any,
      destinationCluster: any,
      selectedRouteMarker: any,
    }

    geoJsonRoutesKey : number = 1;
    userCoords: Types.userCoords;
    destinationsList: Types.DestinationList;
    routesList: Types.RouteList;
    eventsList: Types.EventList;
    locale: string;
    hoveredRoutes: Types.Route[];
    popupProps : {} = {};
    selectedRoute: Types.Route | null = null;
    selectedRouteFeature: Types.Feature | null = null;
    markerFocused: any;

    geoJsonOptions () {
      const self = this;
      return ({
        pointToLayer: (feature: any, latlng: any) => {
          const marker = this.$L.marker(latlng, { icon: this.routesIcon });
          marker.on('mouseover', () => {
            if (!this.selectedRoute) this.spiderfyRouteMarkers(feature, true);
            marker.setIcon(this.focusedIcon);
          });
          marker.on('mouseout', () => {
            if (!this.selectedRoute) this.spiderfyRouteMarkers(null, false);
            if (feature.id !== this.selectedRoute?.id) marker.setIcon(this.routesIcon);
          });
          marker.on('click', async () => {
            const options = {
              explorerType: "ROUTE",
              customId: feature.id,
            };

            self.selectedRouteFeature = feature;
            this.selectedRoute = null;
            this.$nextTick(() => {
              self.$refs.selectedRouteMarker.mapObject.openPopup();
            });

            self.selectedRoute = await this.handlePopupCard(options);

            self.popupProps = {
              route: this.routeItem,
              isInLocalisationContext: this.isInLocalisationContext,
              isExplorerView: true,
            };
          });
          return marker;
        },
      });
    };

    geoJsonRoutes : Types.MapGeojson = {
      "type": "FeatureCollection",
      "features": [],
    };

    destinationItem: Types.DestinationItem | {} = {};
    routeItem: Types.Route | null = null;
    eventItem: Types.Event | null = null;

    actualZoom: number = 15;
    focusedMarker: any = null;

    clusterOptions = {
      animate: false,
      removeOutsideVisibleBounds: false,
      polygonOptions: {
        fillColor: '#1F2A44',
        color: '#1F2A44',
      },
      disableClusteringAtZoom: 18,
      maxClusterRadius: 80,
      chunkedLoading: true,
      chunkInterval: 200,
      chunkDelay: 50,
    };

    objectIsEmpty = objectIsEmpty;

    userIcon = this.$L.icon({
      iconUrl: '/icons/userLocIcon.svg',
      iconSize: [30, 30],
      className: 'userIcon',
    })

    icon = this.$L.icon({
      iconUrl: '/icons/sparkles.svg',
      iconSize: [40, 40],
      iconAnchor: [16, 37],
    });

    routesIcon = this.$L.icon({
      iconUrl: '/icons/PinDepartureCity.svg',
      iconSize: [40, 40],
      iconAnchor: [16, 37],
    });

    focusedIcon = this.$L.icon({
      iconUrl: '/icons/PinFocus.svg',
      iconSize: [40, 40],
      iconAnchor: [16, 37],
      className: 'userIcon',
    });

    eventsIcon = this.$L.icon({
      iconUrl: '/icons/calendar.svg',
      iconSize: [40, 40],
      iconAnchor: [16, 37],
    })

    defaultHeight: string = '550px';

    mapHasBeenMoved: boolean = false;

    isXsDevice: boolean = false;

    panCustom: any = process.client ? window.innerWidth >= 768 ? [300, 100] : [200, 100] : [300, 100];

    isSettingsOpened: boolean = false;
    tileProviders: Types.TileProvider = [
      {
        id: 1,
        name: 'Streets',
        url: `https://api.maptiler.com/maps/streets/{z}/{x}/{y}.png?key=${this.$config.MAPTILER_KEY}`,
        attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      },
      {
        id: 2,
        name: 'Outdoor',
        url: `https://api.maptiler.com/maps/outdoor/{z}/{x}/{y}.png?key=${this.$config.MAPTILER_KEY}`,
        attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      },
      {
        id: 3,
        name: 'Satellite',
        url: `https://api.maptiler.com/tiles/satellite-v2/{z}/{x}/{y}.jpg?key=${this.$config.MAPTILER_KEY}`,
        attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      },
      {
        id: 4,
        name: 'IGN Standard',
        url: ignStandardUrl,
        attribution : "IGN-F/Géoportail",
      },
      {
        id: 5,
        name: 'IGN Scan 25',
        url: ignScan25Url,
        attribution : "IGN-F/Géoportail",
      },

    ]

    currentTile = this.tileProviders[0];
    picked = this.tileProviders[0].name;
    mapHasLoaded: boolean = false;
    allowSelectAreaDisplay: boolean = false;
    defaultEuropeBounds: Array<number[]> = [
      [36.13901207750932, -7.635498046875001],
      [58.53619011845253, 24.005126953125004],
    ];

    defaultWorldBounds: Array<number[]> = [
      [-90, -180],
      [90, 180],
    ];

    isHovering: boolean = false;
    timer: any = null;

    hoveredMarkerId: number | null = null;

    /*
      This method will emit bounds of the map so it can be handled in parent,
      especially to fetch datas in the bounds. It contains multiple logics
      explained below.
      The method is triggered when map is ready (if some preselection datas are
      provided, or not), but also when user will interact with it.
    */
    @Emit('emit-bounds')
    emitBounds () {
      // If route contains a ?seeall=true query, we will returns the entire
      // world bounds and set zoom to display it.
      if (this.$route.query?.seeall) {
        this.$refs.map.mapObject.setZoom(2);
        return {
          _southWest: { lat: this.defaultWorldBounds[0][0], lng: this.defaultWorldBounds[0][1] },
          _northEast: { lat: this.defaultWorldBounds[1][0], lng: this.defaultWorldBounds[1][1] },
        };
      }

      // If user wants to see elements around (data is provided in URL for better
      // handling). A static zoom is set as user pos is based on one single marker.
      // The final bounds are returned in the end of the global method.
      const locQuery: any = this.$route.query?.aroundMe;
      if (
        this.$route.query?.long &&
        this.$route.query?.lat
      ) {
        this.$refs.map.mapObject.setZoom(11);
      }
      if (this.userDefault !== null &&
        (
          objectIsEmpty(this.$route.query) ||
          locQuery?.trim() === 'true' ||
          (Object.keys(this.$route.query).length === 1 &&
          this.$route.query.tab)
        )
      ) {
        this.$refs.map.mapObject.setZoom(11);
      }
      /* // This leaflet util prevents side-effects when user clicks on map to avoid
      // redundant emits of this method.
      this.$L.DomEvent.on(this.$refs.map, 'click', (e) => {
        e.preventDefault();
      }); */

      // We use this.isDisplayed prop to emit the global method when map is
      // displayed, either on activeTab type or mobile design display.
      if (this.isDisplayed) {
        // If active page contains an URL with specified bounds, we will return
        // these bounds.
        if (
          this.$route.query?.longmin &&
          this.$route.query?.latmin &&
          this.$route.query?.longmax &&
          this.$route.query?.latmax
        ) {
          return {
            _southWest: { lat: this.$route.query?.latmin, lng: this.$route.query?.longmin },
            _northEast: { lat: this.$route.query?.latmax, lng: this.$route.query?.longmax },
          };
        }

        // If active pabe contains an URL with a specific place (not bounds),
        // we will return the bounds of the map that are centered on this position.
        if (
          this.$route.query?.long &&
          this.$route.query?.lat
        ) {
          return this.$refs.map.mapObject.getBounds();
        }
        return this.$refs.map.mapObject.getBounds();
      }
      return this.$refs.map.mapObject.getBounds();
    }

    @Watch('routes')
    getGeoJsonRoute () {
      this.geoJsonRoutes = {
        type: 'FeatureCollection',
        features: [],
      };
      this.geoJsonRoutesKey++;
      this.$nextTick(() => {
        this.geoJsonRoutes = {
          type: 'FeatureCollection',
          features: this.routes.map(route => ({
            type: 'Feature',
            id: route.id,
            lat: route.lat,
            lng: route.lng,
            properties: {
              id: route.id,
              lat: route.lat,
              lng: route.lng,
              sport_id: route.properties.sport_id,
              city: route.properties.city,
            },
            geometry: {
              type: 'Point',
              coordinates: [route.lng, route.lat],
            },
            style: this.routesIcon,
          })),
        };
      });
    }

    /*
      When the activeTab in the view changes, we force remove active marker,
      and associated opened popup
    */
    @Watch('activeTab')
    removeFocusedMarkerIfNeeded () {
      if (this.focusedMarker !== null) {
        if (this.$refs.map.mapObject.hasLayer(this.focusedMarker)) {
          this.$refs.map.mapObject.closePopup(this.focusedMarker);
          this.focusedMarker = null;
        }
      }
    }

    /*
      When a route is hovered in page and passed as prop, we will refresh clusters
      in map and spiderfy it if the associated route's marker is displayed in a
      cluster. This method has more logic as when a route is hovered, we also
      want to display associated track on the map.
    */
    @Watch('hoveredRoute')
    spiderfyRouteMarkers (val: Types.Route | { id: number } | null, preventBoolean: boolean) {
      this.$refs.routeCluster?.mapObject.refreshClusters();
      setTimeout(() => {
        this.spiderfyCluster(val, this.$refs.routeCluster);
      }, 200);

      clearTimeout(this.timer);
      if (val) {
        if (preventBoolean) this.hoveredMarkerId = val.id;

        this.isHovering = true;

        if (this.isHovering) {
          this.timer = setTimeout(this.drawHoveredRoute, 50);
        }
      } else {
        this.isHovering = false;
        this.hoveredMarkerId = null;
        for (const i in this.$refs.map.mapObject._layers) {
          if (this.$refs.map.mapObject._layers[i]._path !== undefined) {
            this.$refs.map.mapObject.removeLayer(this.$refs.map.mapObject._layers[i]);
          }
        }
      }
    }

    /*
      When an event is hovered in page and passed as prop, we will refresh clusters
      in map and spiderfy it if the associated event's marker is displayed in a
      cluster
    */
    @Watch('hoveredEvent')
    spiderfyEventMarkers (val: Types.Event) {
      this.$refs.eventCluster.mapObject.refreshClusters();
      setTimeout(() => {
        this.spiderfyCluster(val, this.$refs.eventCluster);
      }, 200);
    }

    /*
      When a destination is hovered in page and passed as prop, we will refresh clusters
      in map and spiderfy it if the associated destination's marker is displayed in a
      cluster
    */
    @Watch('hoveredDestination')
    spiderfyProviderMarkers (val: Types.DestinationItem) {
      this.$refs.destinationCluster.mapObject.refreshClusters();
      setTimeout(() => {
        this.spiderfyCluster(val, this.$refs.destinationCluster);
      }, 200);
    }

    /*
      This watcher will be triggered if parent provides this.customBounds, which
      means if user arrives on the page with preselected datas or coords in
      the URL. Some logic is applied below
    */
    @Watch('customBounds')
    updateBounds (val: any) {
      if (val) {
        // We ensure bounds are correctly fit around user loc if URL contains
        // aroundMe query
        if (this.$route.query && this.$route.query.aroundMe) {
          const query: any = this.$route.query.aroundMe;
          if (query.trim() === 'true') {
            // Fits on the same coords twice as fitBounds needs at least
            // two values
            this.$refs.map?.mapObject?.fitBounds(
              [[val[0], val[1]], [val[0], val[1]]],
            );
            this.$refs.map?.mapObject?.setZoom(11);
          }
        } else if (
          // if custom bounds are the entire world (not ?seeall=true), we will
          // fit on europeanBounds, even if fetched datas will be the entire world
          val[0][1] === -180 &&
            val[0][0] === -90 &&
            val[1][1] === 180 &&
            val[1][0] === 90
        ) {
          this.$refs.map?.mapObject?.fitBounds(
            this.defaultEuropeBounds,
          );
        } else {
          // Default behavior if this.customBounds contains 4 values
          this.$refs.map?.mapObject?.fitBounds(
            [val[0], val[1]],
            [val[2], val[3]],
          );
        }
        // Will trigger this.emitBounds to fetch API datas with the new map bounds
        this.emitBounds();
      }
    }

    // This computed returns the bounds of user coords if has
    // selected aroundMe feature
    get userDefault () {
      return this.userCoords && !this.hideControls
        ? [[this.userCoords.lat, this.userCoords.lng], [this.userCoords.lat, this.userCoords.lng]]
        : null;
    }

    /* If a customHeight is provided by parent, we update the map height */
    created () {
      if (this.customHeight) {
        this.defaultHeight = this.customHeight;
      }
    }

    mounted () {
      this.$root.$on('trigger-bounds-update', (val: number[]) => {
        this.updateBounds(val);
      });

      // This method is triggered to handle map behavior on user scroll based on
      // its window innerWidth
      this.handleWheel();
      // Settings on button (need a ledge setTimeout to let map component load)
      this.$nextTick(() => {
        // Calls the method that will update style of zoom buttons
        this.stylizeZoomControl();

        // If user has selected aroundMe feature, we ensure the map is displayed
        // on the right scale, position and bounds, no matter if the map is
        // updated after mounted.
        if (
          this.userCoords &&
          this.$route.query?.aroundMe === 'true'
        ) {
          this.$refs.map.mapObject.setZoom(11);
        }
      });

      // Ensure "Select in this area" button is hidden the first time the
      // map is mounted, as @update:center on map can be triggered before
      // mounted cycle has finished.
      this.$root.$on('remove-selected-area-button', () => {
        setTimeout(() => {
          this.mapHasBeenMoved = false;
        }, 700);
      });

      // Listening to resize event to handle map behavior
      if (process.client) window.addEventListener('resize', this.handleWheel, false);
    }

    destroyed () {
      // Remove resize event listener when destroying component
      if (process.client) window.removeEventListener('resize', this.handleWheel);
    }

    /*
      This method will use leaflet methods to draw a polyline of the associated
      track of route.
    */
    async drawHoveredRoute () {
      const leafletInstance: any = window.L;

      // We will display hovered or clicked marker, based on available data.
      const idToUse: number = this.hoveredMarkerId ? this.hoveredMarkerId : this.hoveredRoute.id;

      if (!this.hoveredRoutes.some((r: Types.Route) => r.id === idToUse)) {
        await this.$store.dispatch('explorer/getHoveredRoute', { id: idToUse, lang: this.locale });
      }

      const route: any = this.hoveredRoutes.find((r: Types.Route) => r.id === idToUse);

      const array: any = [];
      const track: any = JSON.parse(route.track);
      const object: any = track.features[0].geometry?.coordinates;
      for (let i = 0; i < object.length; i++) {
        array.push([
          object[i][1],
          object[i][0],
        ]);
      }

      const polylineOnMap: any = leafletInstance.polyline(array, { color: this.routeColor(route.difficulty) });
      polylineOnMap.addTo(this.$refs.map.mapObject);
    }

    /* Switch that returns route color based on route difficulty */
    routeColor (val: number) {
      switch (val) {
        case 0: return '#9FA4AE';
        case 1: return '#3FA535';
        case 2: return '#009FE3';
        case 3: return '#CD171A';
        case 4: return '#000';
        default: return '#9FA4AE';
      }
    }

    /*
      This method will spiderfy clusters, which is useful when user hovers
      a card on explorer pages
    */
    async spiderfyCluster (val: any, ref: any) {
      const valId: number = val?.id;
      if (val) {
        // GetLayers is a leaflet method to get every layers on the map. We will
        // get markers layers after to get markers, and filter it to get the
        // active marker based on its popup id. Popup datas are very useful as
        // they contain a lot of datas related to their parent marker, and are
        // easier to handle.
        const markers: any = ref?.mapObject?.getLayers();
        this.markerFocused = this.activeTab === "routes" ? await markers?.find((m: any) => m.feature?.id === valId) : await markers?.find((m: any) => Number(m._popup?._content.id) === valId);
        const L: any = this.$L;

        // This variable will return a string based on cluster type.
        // If it's a div, it means that marker is contain inside a cluster.
        // And in this case, we will want to spiderfy it.
        const typeOfVisibleMarker: string = await L.markerClusterGroup(ref.mapObject).getVisibleParent(this.markerFocused)?._icon.tagName;
        if (this.markerFocused?.__parent._group._spiderfied === null) {
          if (this.markerFocused && typeOfVisibleMarker === 'DIV') {
            this.markerFocused.setIcon(this.focusedIcon);
            this.markerFocused?.__parent.spiderfy();
          }
        }
      }
    }

    /*
      This method is triggered once when map is mounted to define by default map
      bounds, even if these can be updated in a second time based on URL values.
    */
    bounds () {
      if (
        Number(this.$route.query?.longmin) === -180 &&
        Number(this.$route.query?.latmin) === -90 &&
        Number(this.$route.query?.longmax) === 180 &&
        Number(this.$route.query?.latmax) === 90
      ) {
        return this.defaultEuropeBounds;
      }

      // We use this.mapHasLoaded as leaflet has a weird behavior where bounds
      // in template can be caled several times. We just want the map to be
      // init at bounds and avoid redundant front-end logic.
      if (!this.mapHasLoaded) {
        if (this.$route.query?.seeall) {
          return this.defaultWorldBounds;
        }
        if (this.customBounds && this.customBounds.length) {
          this.mapHasLoaded = true;
          return [this.customBounds];
        }
        if (this.userDefault !== null) {
          this.mapHasLoaded = true;
          return this.userDefault;
        };
        return this.defaultEuropeBounds;
      }
    }

    /*
      When user clicks "Select in this area", we will emit map bounds so we will
      fetch associated datas with API calls. It also resets arrays of datas
      displayed on explorerPage, so it cleans them and returns an all new array
      populated with new elements fetched.
    */
    updateQuery () {
      this.$store.commit('explorer/SET_EXPLORER_BOUNDS', {});

      this.$root.$emit('selected-area', this.$refs.map.mapObject.getBounds());
      this.$emit('reset-append');
      this.$emit('emit-bounds', this.$refs.map.mapObject.getBounds());
      this.$emit('update-query');
    }

    /* Resets store values */
    destroyMap () {
      // this.$refs.map.mapObject.remove();
      this.$store.commit('explorer/SET_LOCALISATION_MAP_DISPLAY', false);
    }

    /* This method applies custom styles to zoom buttons of map. */
    stylizeZoomControl () {
      if (process.client) {
        const plus: any = document.getElementsByClassName("leaflet-control-zoom-in")[0];
        const minus: any = document.getElementsByClassName("leaflet-control-zoom-out")[0];

        // content
        plus.innerHTML = "";
        minus.innerHTML = "";

        if (this.hideControls) {
          this.$refs.map.mapObject.dragging.disable();

          document.querySelectorAll('.leaflet-control-container').forEach((item: any) => {
            item.style.display = 'none';
          });
        } else if (this.customHeight) {
          document.querySelectorAll('.leaflet-top.leaflet-right').forEach((item: any) => {
            item.style.marginTop = '6rem';
            item.style.marginRight = '1.5rem';
          });

          document.querySelectorAll('.leaflet-top.leaflet-left').forEach((item: any) => {
            item.style.marginTop = '6rem';
            item.style.marginLeft = '1.5rem';
          });
        } else {
          document.querySelectorAll('.vue2leaflet-map').forEach((item: any) => {
            item.style.borderRadius = '0.5rem';
          });
        }
      }
    }

    /*
      When user clicks arrow button, we fly to user location and
      set static zoom
    */
    goToUserLoc () {
      this.$refs.map.mapObject.setZoom(11);
      this.$refs.map.mapObject.flyTo(
        [this.userCoords.lat, this.userCoords.lng],
      );
    }

    /*
      Toggle maps settings
    */
    toggleMapSettings () {
      this.isSettingsOpened = !this.isSettingsOpened;
    }

    /*
      Change layer of the current map
    */
    changeTile (index: number) {
      this.currentTile = this.tileProviders[index];
    }

    /*
      This timeout is used to handle "Select in this area" behavior, as it can
      sometimes be displayed when map mounted, which is something we don't want
    */
    allowHandleSelect () {
      setTimeout(() => {
        this.allowSelectAreaDisplay = true;
      }, 1000);
    }

    /*
      This method is called in mounted and in resize event listener.
      In mobile devices, we don't want the user to be able to scroll like a
      scrollWheelZoom type
    */
    handleWheel () {
      if (process.client) {
        if (window.innerWidth < 321) {
          this.isXsDevice = true;
        } else {
          this.isXsDevice = false;
        }

        if (window.innerWidth < 768) {
          if (this.$refs.map.mapObject.scrollWheelZoom.enabled()) {
            this.$refs.map.mapObject.scrollWheelZoom.disable();
          }
        } else {
          this.$refs.map.mapObject.scrollWheelZoom.enable();
        }
      }
    }

    /*
      This method works this way : it will populate the popup content based on
      selected marker by user when he clicks it.
      - If the content of the marker hasn't been fetched and isn't known in the
      store, we will fetch it and append it to the store array.
      - If the content of the marker has been fetched one time, we won't fetch it
      again and will use the value kept in store
    */
    async addFocusedIcon (val: any) {
      val.popup._source.setIcon(this.focusedIcon);
      this.focusedMarker = val.popup;

      await this.handlePopupCard(val.popup.options);
      if (this.activeTab === 'routes') await this.spiderfyRouteMarkers({ id: val.popup.options.customId }, true);
    }

    /*
      When user hovers an icon on map, se use leaflet method to update icon's style
    */
    addHoveredIcon (val: any) {
      val.sourceTarget.setIcon(this.focusedIcon);
    }

    /*
      Same logic than this.addHoveredIcon but removes the activeIcon style.
      If marker was a route/spot marker, we ensure the style is the right one when
      reset
    */
    removeHoveredIcon (val: any, type: string) {
      if (!this.focusedMarker) val.sourceTarget.setIcon(this.routesIcon);
    }

    /*
      This method works this way : it will populate the popup content based on
      selected marker by user when he clicks it.
      - If the content of the marker hasn't been fetched and isn't known in the
      store, we will fetch it and append it to the store array.
      - If the content of the marker has been fetched one time, we won't fetch it
      again and will use the value kept in store
    */
    async handlePopupCard (options: any) {
      // If the element exists in store, we will use it and avoid redundant API call
      const existsInList: Function = (list: any) => {
        return list?.items.some((item: Types.Route | Types.DestinationItem | Types.Event) => item.id === options.customId);
      };

      // Switch to handle right action to do based on marker type
      // The switch will return an object that will be used in the template to
      // render the card in popup.
      switch (options.explorerType) {
        case 'ROUTE': {
          const existsInRouteList: boolean = existsInList(this.routesList);
          this.routeItem = null;
          /* eslint no-return-assign: 0 */
          if (existsInRouteList) return this.routeItem = this.routesList.items.find((item: Types.Route) => item.id === options.customId);
          else {
            await this.$store.dispatch('explorer/getRoute', { id: options.customId, lang: this.locale, appendToRoutesList: true });
            return this.routeItem = this.routesList.items.find((item: Types.Route) => item.id === options.customId) || {};
          }
        };

        case 'DESTINATION': {
          const existsInDestinationsList: boolean = existsInList(this.destinationsList);
          this.destinationItem = {};
          /* eslint no-return-assign: 0 */
          if (existsInDestinationsList) return this.destinationItem = this.destinationsList.items.find((item: Types.Route) => item.id === options.customId);
          else {
            await this.$store.dispatch('explorer/getDestination', { id: options.customId, lang: this.locale, appendToRoutesList: true });
            return this.destinationItem = this.destinationsList.items.find((item: Types.Route) => item.id === options.customId) || {};
          }
        };

        case 'EVENT': {
          const existsInEventsList: boolean = existsInList(this.eventsList);
          this.eventItem = null;
          /* eslint no-return-assign: 0 */
          if (existsInEventsList) return this.eventItem = this.eventsList.items.find((item: Types.Event) => item.id === options.customId);
          else {
            await this.$store.dispatch('explorer/getEvent', { id: options.customId, lang: this.locale, appendToRoutesList: true });
            return this.eventItem = this.eventsList.items.find((item: Types.Event) => item.id === options.customId) || {};
          }
        };
      }
    }

    /*
      Following the same logic than this.addFocusedIcon, this method will reset
      the activeMarker icon to its default one. It also resets every datas
      associated and handled by this.addFocusedIcon.
    */
    async removeFocusedIcon (val: any) {
      let icon: any = this.icon;
      // Using custom object datas declared in template to get marker type easily
      const popupClass: string = val.popup.options.explorerType;
      if (popupClass === 'ROUTE') icon = this.routesIcon;
      if (popupClass === 'EVENT') icon = this.eventsIcon;
      if (popupClass === 'DESTINATION') icon = this.icon;
      val.popup._source.setIcon(icon);
      this.routeItem = null;
      this.destinationItem = {};
      this.eventItem = null;
      this.focusedMarker = null;
      this.selectedRoute = null;
      this.markerFocused.setIcon(this.routesIcon);
      await this.spiderfyRouteMarkers(null, false);
    }
}
